import { createFileRoute, redirect } from '@tanstack/react-router';
import { useTranslator } from '@/hooks/useTranslator';
import { PurchaseOrdersLayout } from '../../../-components/PurchaseOrdersLayout';

export const Route = createFileRoute(
  '/(client)/orders/(pages)/(list)/purchase-orders',
)({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === '/orders/purchase-orders' ||
      location.pathname === '/orders/purchase-orders/'
    ) {
      throw redirect({
        to: '/orders/purchase-orders/active',
        search: { aiSummaryId: undefined, aiOrderNumber: undefined },
      });
    }
  },
  component: PurchaseOrdersLayoutRoute,
});

function PurchaseOrdersLayoutRoute() {
  const { getTranslation: t } = useTranslator({ page: 'orders' });
  return (
    <PurchaseOrdersLayout
      activeLabel={t('toggle.active')}
      archiveLabel={t('toggle.archive')}
    />
  );
}
